import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router'

import * as ROUTES from 'config/routes'
import ZoneEdit from './zone-edit'
import ZoneList from './zone-list'
import ZoneAdd from './zone-add'
import { PageContent } from 'components'
import { PageContainer } from 'smart-components'
import { userIsAuthenticatedRedir } from 'hocs/auth'

const Zone = () => (
    <PageContainer>
        <PageContent>
            <PageContent.Main>
                <Switch>
                    <Route
                        exact
                        path={ROUTES.ZONE}
                        component={ZoneList}
                    />
                    <Route
                        exact
                        path={ROUTES.ZONE_EDIT}
                        component={ZoneEdit}
                    />
                    <Route
                        exact
                        path={ROUTES.ZONE_ADD}
                        component={ZoneAdd}
                    />
                </Switch>
            </PageContent.Main>
        </PageContent>
    </PageContainer>
)

export default userIsAuthenticatedRedir(Zone)



// WEBPACK FOOTER //
// ./src/pages/zone/index.js